export default "__VITE_ASSET__D1VyctM4__"